export const init = {
  isLoading: false,
  isStatus: true,
  expireToken: false,
  data: false,
}
